<script setup lang="ts">
useHead({
  title: 'MetalMusicMadness'
});

const authLoading = useState<boolean>('authLoading', () => true)

watch(authLoading, () => {
  setBackRoute('/', true)
  return navigateTo('/')
})
</script>

<template>
  <q-layout>
    <q-page-container>
      <NuxtPage />
    </q-page-container>
  </q-layout>
</template>

<style scoped>

</style>